import React from 'react';
import moment from 'moment';

import { connect } from 'react-redux';
import Translate from 'translate';
import { Form } from 'react-form';
import Table from 'components/HTMLElements/Table/Custom';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import UserService from 'services/UserService';
import Service from 'services/ServiceService';
import ReportService from 'services/ReportService';
import { FormGroup, Text, Select, InputDate } from 'components/FormElements';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/file/file-download';
import MenuItem from 'material-ui/MenuItem';
class ExecutivePerUserReport extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: new Date(),
      dateTo: new Date(),
      data: [],
      user: [],
      service: [],
      deleteModalOpened: false,
      userId: 0,
      serviceId: 0,
      sources: [  ],
    };
    this.download = '';
    this.search = {};
    this.getData = this.getData.bind(this);
  }

  componentDidMount() {
    const {chatActive, phoneActive} = this.props;
    let sources = [        
      {id:'facebook',name:'facebook'},
      {id:'twitter',name:'twitter'},
      {id:'email',name:'email'},
      {id:'walk_in',name:'walkin'},
    ];

    if (chatActive){
      sources.push( {id:'chat',name:'chat'})
    }

    if (phoneActive){
      sources.push( {id:'phone',name:'phone'})
    }
    this.setState({sources});
    this.getData(this.params);
    this.getReport(this.params);
  }
  getData(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);

    UserService.getUsers({limit:-1}).then(response => {
      

      if (response.data) {
        let newUsers = [];
        newUsers =_.map(response.data.data, (item) =>{
          return {name: item.name +' '+ item.lastName, id:item.id}
        }) 
        this.setState({
          user: newUsers
        });
      }
      //toggleLoading(false);
    });

    /*Service.getServices().then(response => {
      toggleLoading(false);

      if (response.data) {
        this.setState({
          service: response.data.data
        });
      }
    });*/
  }

  getReport(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);
    const apiParams = {
      dateFrom: moment(this.state.dateFrom).format('YYYY-MM-DD') ,
      dateTo: moment(this.state.dateTo).format('YYYY-MM-DD') 
    };

    if (this.state.userId){
      apiParams.userId = this.state.userId
    }
    if (this.state.serviceId){
      apiParams.types = this.state.serviceId
    }
    if (this.download !== '' ) {
      apiParams.download = this.download
    }

    ReportService.getReportsEntriesDismissed(apiParams).then(response => {
      toggleLoading(false);
      if (this.download !== '') {
        window.location.href = response.data.uri;
      } else {
        if (response.data) {
          this.setState({
            data: response.data
          });
        }
      }

    });
  }

  handleDateChangeDateFrom = e => {
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    this.setState({ dateTo: e });
  };
  handleChange = e => {
    this.setState({ userId: e});
  };

  handleChangeService = e => {
    this.setState({ serviceId: e.target.value });
  };

  handleChangeSource = e => {
    let x = []
    _.map( e, ( item, index ) => {
      //console.log( _.get( item, 'id' ) );
      x[index]=_.get( item, 'id' )

    });
    this.setState({ serviceId: x});
  };

  submitForm = data => {
    this.search = data;
    //this.getReport(this.params);
  };

  render() {
    const {
      userId,
      serviceId,
      data,
      sources,
      user,
      dateFrom, 
      dateTo
    } = this.state;
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <h4>
            <Translate id="report.entriesDismissed" />
          </h4>
        </div>
        <div>
          <Form onSubmit={this.submitForm}>
            {({ submitForm }) => (
              <form onSubmit={submitForm} className="d-flex">
                <FormGroup containerClass="col-md-2">

                  <label className={'MuiFormLabel-root MuiInputLabel-shrink'} ><Translate id="report.username"/></label>
                  <Select field="userId" className="form-control" 
                          placeholder={<Translate id="report.selectSource" />}
                          labelKey="name"
                          valueKey="id"
                          simpleValue={true}  
                          onChange={this.handleChange}
                          options={user}/>
                </FormGroup>
                <FormGroup containerClass="col-md-2">

                  <label className={'MuiFormLabel-root MuiInputLabel-shrink'} ><Translate id="report.channel"/></label>
                  <Select field="serviceId" className="form-control" 
                          placeholder={<Translate id="report.selectSource" />}
                          labelKey="name"
                          valueKey="id"
                          simpleValue={false} multi 
                          onChange={this.handleChangeSource}
                          options={sources}/>
                </FormGroup>
                <FormGroup containerClass="col-md-2">
                  <InputDate
                    label={<Translate id="report.dateFrom" />}
                    value={dateFrom}
                    onChange={this.handleDateChangeDateFrom}
                  />
                </FormGroup>

                <FormGroup containerClass="col-md-2">
                  <InputDate
                    label={<Translate id="report.dateTo" />}
                    value={dateTo}
                    onChange={this.handleDateChangeDateTo}
                  />
                </FormGroup>
                <div className="col-md-2 pl-0">
                  <button
                    style={{ marginTop: '20px', marginLeft: '0px' }}
                    type="submit"
                    className="btn btn-info mr-2 px-3"
                    onClick={() => {
                      this.search = {};
                      this.download = '';
                      this.getReport(userId, serviceId);
                    }}
                  >
                    <i className="fa fa-search pointer" />
                  </button>
                </div>

                <div className="col-md-2 pl-0 text-right">


                  <IconMenu style={{ height: '20px' }}
                        iconButtonElement={
                          <IconButton touch className="btn-account">
                            <NavigationExpandMoreIcon/>
                          </IconButton>
                        }>
                  <MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'excel';
                      this.getReport(userId, serviceId);
                    }}
                    key={1}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-excel-o pointer" /> CSV 
                  </MenuItem>
                  {/*<MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'pdf';
                      this.getReport(
                        value,
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={2}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-pdf-o pointer" /> Pdf
                  </MenuItem>
                  */}
                  </IconMenu>
                </div>


              </form>
            )}
          </Form>
          <div className="box-body">
            <Table
              className="app-table-report"
              data={data}
              columns={[
                {
                  Header: <Translate id="report.dataLogged" />,
                  accessor: 'dateLogged'
                },
                {
                  Header: <Translate id="report.client" />,
                  accessor: 'client'
                },
                {
                  Header: <Translate id="report.loggedBy" />,
                  accessor: 'loggedBy'
                },
                {
                  Header: <Translate id="report.loggedByName" />,
                  accessor: 'name'
                },
                {
                  Header: <Translate id="report.source" />,
                  accessor: 'source'
                },
                {
                  Header: <Translate id="report.serviceName" />,
                  accessor: 'serviceName'
                },
                {
                  Header: <Translate id="status" />,
                  accessor: 'status'
                },
                {
                  Header: <Translate id="updatedAt" />,
                  accessor: 'updatedAt'
                },
                {
                  Header: <Translate id="category" />,
                  accessor: 'categoryName'
                },
                {
                  Header: <Translate id="dismissReason" />,
                  accessor: 'dismissReason'
                }
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.settings.isLoading,
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: message => {
    dispatch(toggleAlertError(message));
  },
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(ExecutivePerUserReport);



// WEBPACK FOOTER //
// ./routes/app/routes/reports/EntriesDismissed/index.js